// Controls
import { useDndDragLayerStyles } from "./DndDragLayer.styles";
// Utilities
import React, { useMemo } from "react";
import { useDragLayer } from "react-dnd";
import { customizeStyles } from "../utilities/StyleUtilities";
/**
 * Custom drag layer to render a preview of the dragged item.
 */ export const DndDragLayer = ()=>{
    const { isDragging, item, initialOffset, currentOffset, clientOffset } = useDragLayer((monitor)=>({
            item: monitor.getItem(),
            initialOffset: monitor.getInitialSourceClientOffset(),
            currentOffset: monitor.getSourceClientOffset(),
            clientOffset: monitor.getClientOffset(),
            isDragging: monitor.isDragging()
        }));
    const styles = customizeStyles(useDndDragLayerStyles(), item?.previewElement?.styles);
    const previewItem = useMemo(()=>{
        return item?.previewElement?.render?.() ?? null;
    }, [
        item
    ]);
    /**
     * Get inline styles for the preview item as makeStyles cannot be used here.
     */ const getPreviewStyles = ()=>{
        if (item?.previewElement?.anchorToPointerCenter) {
            if (!clientOffset) {
                return {
                    display: "none"
                };
            }
            const { x, y } = clientOffset;
            return {
                transform: `translate(${x}px, ${y}px) translate(-50%, -50%)`
            };
        }
        if (!initialOffset || !currentOffset) {
            return {
                display: "none"
            };
        }
        // Get default transform to move the preview item to the current position
        const { x, y } = currentOffset;
        return {
            transform: `translate(${x}px, ${y}px)`
        };
    };
    if (!isDragging) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.root
    }, /*#__PURE__*/ React.createElement("div", {
        style: getPreviewStyles(),
        className: styles.container
    }, previewItem));
};
